import {useTranslation} from 'react-i18next';
import Row from '../../../common/component/Row';
import SingleText from '../../../common/component/SingleText';
import Text from '../../../common/component/Text';
import {ITicketType} from '../../../common/type';
import {IContentTicketType, IContentUsedTicketItem} from '../../type';

interface IProps {
  usedItem: IContentUsedTicketItem;
  contentTicketType: IContentTicketType;
}

export default function ContentTicketUsedItemV4({
  usedItem,
  contentTicketType,
}: IProps) {
  const {t} = useTranslation();
  const {episode, type, usedDate} = usedItem;
  const isContentTicketTab = contentTicketType === 'contentTicketTab';

  return (
    <>
      <SingleText
        className={cn(
          isContentTicketTab
            ? 's14-medium-white opacity-85'
            : 's14-medium-white light:text-black'
        )}
      >
        {episode.title}
      </SingleText>
      <Row
        className="mt-8"
        rightElement={
          <Text
            className={cn(
              isContentTicketTab
                ? 's13-regular-white opacity-50'
                : 's13-regular-grey06'
            )}
          >
            {t(CONTENT_TICKET_USED_TEXT_KEY_MAP[type])}
          </Text>
        }
      >
        <Text
          className={cn(
            isContentTicketTab
              ? 's13-regular-white opacity-50'
              : 's13-regular-grey06'
          )}
        >
          {usedDate}
        </Text>
      </Row>
    </>
  );
}

const CONTENT_TICKET_USED_TEXT_KEY_MAP: {[key in ITicketType]: string} = {
  rental: 'common_ticket_rental',
  possession: 'common_ticket_possession',
  waitForFree: 'common_ticket_gidamu',
  gift: 'contenthome_tickethistory_used_gift_event',
  welcomeGift: 'contenthome_tickethistory_used_gift_newbie',
};
